import React from 'react';
import { useNavigate } from 'react-router-dom';
import ViewportList from 'react-viewport-list';
// Mui
import Menu from '@mui/material/Menu';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Badge from '@mui/material/Badge';
// Components
import NotificationItem from './NotificationItem';
// Interface
import { Notification as NotificationObject } from 'src/app/models/AppNotification';
// Icons
import ClearIcon from '@mui/icons-material/Clear';
import NotificationsNoneSharpIcon from '@mui/icons-material/NotificationsNoneSharp';

interface Iprops {
    notifications: NotificationObject[];
    notificationResolve: (id: string) => void;
    notificationClose: (id: string) => void;
}

function notificationsLabel(count: number) {
    if (count === 0) {
        return 'no notifications';
    }
    if (count > 99) {
        return 'more than 99 notifications';
    }
    return `${count} notifications`;
}

function NotificationList({ notifications, notificationResolve, notificationClose }: Iprops) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const ref = React.useRef(null);
    const navigate = useNavigate();
    const openActionModel = Boolean(anchorEl);

    const handleActionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleActionClose = () => {
        setAnchorEl(null);
    };

    const gotoAlerts = () => {
        navigate('admin/alerts');
        handleActionClose();
    };

    const gotoBooking = (bookingRef, journeyRef) => {
        navigate(`/customer/bookings/${bookingRef}/${journeyRef}`);
        handleActionClose();
    };

    return (
        <>
            <Box
                sx={{
                    height: '48px',
                    width: '48px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    background: 'white',
                }}
            >
                <IconButton
                    aria-controls='booking-action-menu'
                    aria-haspopup='true'
                    aria-label={notificationsLabel(notifications.length)}
                    onClick={handleActionClick}
                    disableRipple
                    sx={{
                        p: 0,
                        background: 'transparent',
                    }}
                >
                    <Badge
                        color='error'
                        badgeContent={notifications.length}
                        max={99}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        showZero
                    >
                        <NotificationsNoneSharpIcon />
                    </Badge>
                </IconButton>
            </Box>

            <Menu
                ref={ref}
                id='booking-action-menu'
                anchorEl={anchorEl}
                open={openActionModel}
                onClose={handleActionClose}
                MenuListProps={{
                    'aria-labelledby': 'booking-action-button',
                }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                sx={{
                    '> .MuiPaper-root': {
                        px: '20px',
                        py: '22px',
                        borderRadius: '20px',
                        '::-webkit-scrollbar': {
                            width: '8px',
                        },
                        '::-webkit-scrollbar-track-piece:end': {
                            background: 'transparent',
                            marginBottom: '30px',
                        },
                        '::-webkit-scrollbar-track-piece:start': {
                            background: 'transparent',
                            marginTop: '30px',
                        },
                        '::-webkit-scrollbar-track-piece': {
                            backgroundColor: 'transparent',
                        },
                        '::-webkit-scrollbar-thumb': {
                            borderRadius: '4px',
                            backgroundColor: 'rgba(0, 0, 90, 0.08)',
                        },
                        '> .MuiList-root': {
                            maxWidth: '560px',
                        },
                    },
                }}
            >
                <Box
                    sx={{
                        width: ['100%', '100%', 'max-content'],
                        display: ['flex', 'flex', 'inherit'],
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        ml: 'auto',
                        mb: 3,
                    }}
                >
                    <Typography
                        component='span'
                        sx={{
                            fontSize: '0.875rem',
                            cursor: 'pointer',
                            color: (t) => t.palette.purple.main,
                        }}
                        onClick={gotoAlerts}
                    >
                        View in Alerts
                    </Typography>
                    <IconButton sx={{ p: 0, ml: 6 }} onClick={handleActionClose}>
                        <ClearIcon />
                    </IconButton>
                </Box>

                {notifications.length > 0 ? (
                    //     notifications.map((n, i) => {
                    //     if (n.NotificationStatus !== 1) { return false };
                    //     const context = getWindowType[n.NotificationType - 1];
                    //     return <NotificationItem
                    //         key={i}
                    //         notification={n}
                    //         gotoBooking={gotoBooking}
                    //         notificationResolve={notificationResolve}
                    //         notificationClose={notificationClose}
                    //     />
                    // })

                    // <List
                    //     itemCount={notifications.length}
                    //     itemSize={50}
                    //     height={400}
                    //     itemData={notifications}
                    //     // useIsScrolling
                    // >
                    //     {NotificationItem}
                    // </List>

                    <ViewportList viewportRef={ref} items={notifications} itemMinSize={40}>
                        {(item) => (
                            <NotificationItem
                                key={item.NotificationId}
                                notification={item}
                                gotoBooking={gotoBooking}
                                notificationResolve={notificationResolve}
                                notificationClose={notificationClose}
                            />
                        )}
                    </ViewportList>
                ) : (
                    <Box sx={{ width: '240px' }}>
                        <Typography sx={{ lineHeight: '24px', color: (t) => t.palette.alpha.gray['opaque'] }}>
                            No notifications to see
                        </Typography>
                    </Box>
                )}
            </Menu>
        </>
    );
}

export default NotificationList;
